import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppService } from "../../../../../services/app.service";
import { Observable } from "rxjs";
import { Recurso } from "../models/recurso";
import { AppFilter } from "app/models/app-filter.model";
import { RecursoDivisaoArea } from "../models/recurso-divisao-area";

@Injectable({providedIn:'root'})
export class RecursoService extends AppService {
    prefixo = "recursos";

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public desativar(id: number) {
        return this.delete(`${this.prefixo}/`, id);
    }

    public getAllRecursos(filter: AppFilter) {
        return this.get(`${this.prefixo}/filter/${filter.encode()}`);
    }

    public getAllZonas(zonaId: number) {
        return this.get(`${this.prefixo}/all/`, zonaId);
    }

    public getRecurso(id: number) {
        return this.get(`${this.prefixo}/`, id);
    }

    public saveRecurso(recurso: Recurso): Observable<Recurso> {
        return this.save(`${this.prefixo}/`, recurso);
    }

    public ListByDivisao(divisaoId: number) {
        return this.get('recursos_divisoes_areas/divisoes/', divisaoId).toPromise();
    }

    public ListByArea(areaId: number) {
        return this.get('recursos_divisoes_areas/areas/', areaId).toPromise();
    }

    public saveRecursoDivisaoArea(rda: RecursoDivisaoArea) {
        return this.post('recursos_divisoes_areas/create/', rda);
    }

}